import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import * as moment from 'moment';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { StyleService } from '../../services/style.service';
@Component({
  selector: 'app-time-picker',
  template: `
<div class="hazard-description time-picker" [formGroup]="group" *ngIf="field.style.visibility && !field.dynamic">
  <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
  <div [ngStyle]="_styleService.applyStyle(field)" [ngClass]="{'pointer-events' : !field.style.editability}" class="date-fixed-on flt-select-style" (click)="prefilledFieldsConfig.displayTimePicker = !prefilledFieldsConfig.displayTimePicker">
    <input class="form-control">
    <p>{{(field.value !== '' && field.value !== undefined) ?  (field.value | date: "shortTime" ) : 'Time'}}</p>
  </div>
  <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  <div *ngIf="prefilledFieldsConfig.displayTimePicker" class="time-picker-show">
    <ngb-timepicker [(ngModel)]="time" [meridian]="meridian" (ngModelChange)="fireOnChange($event)" [ngModelOptions]="{standalone : true}"></ngb-timepicker>
  </div>
</div>
<div class="hazard-description time-picker dynamic-property" [formGroup]="group" *ngIf="field.dynamic && field.style.visibility" [ngClass]="{'pointer-events' : !field.style.editability}">
  <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
  <div *ngFor="let x of field.value; let i = index;trackBy:trackByIndex;" class="inputfields">
    <div class="date-fixed-on flt-select-style" (click)="clicked(i)">
      <input class="form-control dynamic-input">
      <p>{{(field.value[i] !== '' && field.value[i] !== undefined) ?  (field.value[i] | date: "shortTime" ) : 'Time'}}</p>
      <ng-container *ngIf="deleteShow">
      <div class="btn delete-item time-picker-dynamic" (click)="deletShortText(i)"><img src="assets/rff-images/delete-dynamic.svg"></div>
      </ng-container>
      </div>
      <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
      <div *ngIf="show === i && show >=0" class="time-picker-show">
        <ngb-timepicker [(ngModel)]="myTime" [meridian]="meridian" (ngModelChange)="fireOnDynamicChange($event,i)" [ngModelOptions]="{standalone : true}"></ngb-timepicker>
      </div>
  </div>
    <div class="btn-dynamic">
      <div class="btn btn-default" (click)="dynamicDatePicker()"><img src="assets/rff-images/add-img.svg"> Add another field</div>
      </div>
    </div>
    `,
  styles: [`.date-fixed-on{background: url(assets/rff-images/time-picker1.svg) no-repeat 97% 54%;`]
})
export class TimePickerComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  time;
  times = [];
  myTime: any;
  meridian = true;
  getTime: any;
  public show: number = -1;
  deleteShow = false;

  prefilledFieldsConfig = {
    displayTimePicker: false
  };

  constructor(
    private _validationService: ValidationService,
    private _styleService: StyleService
  ) {}

  fireOnChange(timeObj) {
    let onChnage = ()=>{
      this.group.value[this.field.id] = this.field.value;
      const data = this.group.value;
      this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
    }
    if (timeObj) {
      let time = moment().toDate();
      time.setHours(timeObj.hour);
      time.setMinutes(timeObj.minute);
      this.field.value = moment.utc(time).format();
      onChnage();
    }else{
      let utcDate = new Date();
        this.time = {
          hour: utcDate.getHours(),
          minute: utcDate.getMinutes()
        }
        this.field.value = moment.utc(this.field.value).format();
        onChnage();
    }
  }

  // dynamic field timepicker
  clicked(index) {
    if (this.show === index) {
      this.show = -1;
    } else {
      this.show = index;
    }
    if (this.field.value !== '') {
      this.myTime = this.times[index];
    }
  };
  fireOnDynamicChange(timeObj, index) {
    if (timeObj) {
      let time = moment().toDate();
      time.setHours(timeObj.hour);
      time.setMinutes(timeObj.minute);
      this.times[index].hour = timeObj.hour;
      this.times[index].minute = timeObj.minute;
      let utcConvertDate = moment.utc(time).format();
      this.field.value = Object.assign([], this.field.value, {
        [index]: utcConvertDate
      });
      this.group.value[this.field.id] = this.field.value;
    }
  }
  trackByIndex(index: number) {
    return index;
  }
  dynamicDatePicker() {
    this.field.value.push(moment.utc(new Date()).format());
    var utcDate = new Date();
    let NumberOftime = {
      hour: utcDate.getHours(),
      minute: utcDate.getMinutes()
    }
    this.times.push(NumberOftime);
    this.deleteShow = true;
  }
  deletShortText(i) {
    this.field.value.splice(i, 1);
    if (i === 1) {
      this.deleteShow = false;
    }
  }

  ngOnInit() {
    // dynamic is true
    if (this.field.dynamic) {
      if (this.field.value === undefined) {
        this.field.value = new Date();
        var utcDate = this.field.value;
        let NumberOftime = {
          hour: utcDate.getHours(),
          minute: utcDate.getMinutes()
        }
        this.times.push(NumberOftime);
        this.field.value = [moment.utc(this.field.value).format()];
      } else {
        _.forEach(this.field.value, (val, key) => {
          let utcDate = new Date(this.field.value[key]);
          let NumberOftime = {
            hour: utcDate.getHours(),
            minute: utcDate.getMinutes()
          }
          this.times.push(NumberOftime);
          this.field.value = Object.assign([], this.field.value, {
            [key]: val
          });
        })
      }
    }
    // dynamic is not true
    
    let checkTime = (utcDate) => {
      this.time = {
        hour: utcDate.getHours(),
        minute: utcDate.getMinutes()
      }
      this.field.value = moment.utc(this.field.value).format();
    }
    if (!this.field.dynamic && ((this.field.default && this.field.default.type === "current") || !this.field.default || this.field.default.value)) {
      if (this.field.value === undefined) {
        this.field.value = new Date();
        checkTime(this.field.value);
      } else {
        checkTime(new Date(this.field.value));
      }
    }
    if(!this.field.dynamic && this.field.default && this.field.default.type === 'none' && this.field.value){
      checkTime(new Date(this.field.value));
    }
    if (this.field.dynamic && this.field.value.length > 1) {
      this.deleteShow = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/time-picker/time-picker.component.ts